import { render, staticRenderFns } from "./cancelShipment.vue?vue&type=template&id=50437e4f&scoped=true"
import script from "./cancelShipment.vue?vue&type=script&lang=js"
export * from "./cancelShipment.vue?vue&type=script&lang=js"
import style0 from "./cancelShipment.vue?vue&type=style&index=0&id=50437e4f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50437e4f",
  null
  
)

export default component.exports